import { render, staticRenderFns } from "./MaintenanceAlert.vue?vue&type=template&id=706ad76a&scoped=true&"
import script from "./MaintenanceAlert.vue?vue&type=script&lang=js&"
export * from "./MaintenanceAlert.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceAlert.vue?vue&type=style&index=0&id=706ad76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ad76a",
  null
  
)

export default component.exports